// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, ButtonSize} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import * as Tooltip from '@wandb/weave/components/RadixTooltip';
import React from 'react';

type OverflowMenuProps = {
  children: React.ReactNode;
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
  buttonSize?: ButtonSize | undefined;
};

export const PanelOverflowMenu = ({
  isMenuOpen,
  setIsMenuOpen,
  children,
  buttonSize,
}: OverflowMenuProps) => {
  return (
    <Tooltip.Provider>
      <DropdownMenu.Root
        open={isMenuOpen}
        onOpenChange={setIsMenuOpen}
        modal={false} // Setting this to false so it doesn't interfere with focus
      >
        <DropdownMenu.Trigger asChild>
          <Button
            active={isMenuOpen}
            icon="overflow-horizontal"
            variant="ghost"
            aria-label="More panel actions"
            size={buttonSize ?? 'small'}
          />
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>{children}</DropdownMenu.Portal>
      </DropdownMenu.Root>
    </Tooltip.Provider>
  );
};
